import React, { useMemo } from 'react';
import { Card, Space, Tag } from 'antd';
import { ClockCircleTwoTone, CreditCardTwoTone } from '@ant-design/icons';
import cx from 'classnames';
import styles from './PackageTile.module.css';
import { formatDuration } from 'src/helpers/formatters';

const emptyImageIcon = process.env.PUBLIC_URL + '/icons/empty-image-icon.svg';

export interface PackageTileProps {
  image: string;
  name: string;
  description: string;
  price: string | number;
  duration: number;
  archived?: boolean;
  active?: boolean;
  vipAccess: boolean;
  promo: boolean;
  className?: string;
  style?: React.CSSProperties;
  isKids: boolean;
}

const PackageTile: React.FC<PackageTileProps> = props => {
  const { isKids, name, description, duration, image, price, className, style, active, archived, vipAccess, promo } =
    props;

  const durationFormatted = useMemo(() => {
    return formatDuration(duration);
  }, [duration]);

  return (
    <Card
      className={className}
      style={style}
      cover={
        <div className={styles.imageWrap}>
          <svg className={styles.imageViewBox} viewBox='0 0 16 9' />
          <img
            className={cx({
              [styles.image]: image,
              [styles.imageStub]: !image,
            })}
            src={image || emptyImageIcon}
            alt=''
          />
        </div>
      }
      actions={[
        <Space key='price'>
          <CreditCardTwoTone />
          <span key='price'>{price} ₽</span>
        </Space>,
        <Space key='duration'>
          <ClockCircleTwoTone />
          <span>{durationFormatted}</span>
        </Space>,
      ]}
      hoverable
    >
      <Card.Meta
        title={
          <Space direction='vertical'>
            {name}
            <Space direction={'horizontal'}>
              {vipAccess && <Tag color='green'>VIP Доступ</Tag>}
              {promo && <Tag color='blue'>Промо</Tag>}
              {isKids && <Tag color='orange'>Детский</Tag>}
              {archived && <Tag color='red'>Архивирован</Tag>}
              {active && <Tag color='green'>Активирован</Tag>}
            </Space>
          </Space>
        }
        description={description}
      />
    </Card>
  );
};

export default PackageTile;
